import { apiClient } from '@shared/api/client';

/**
 * Entity별 Director 및 Shareholder 목록 조회 (Controller 전용)
 * @param entityCd - Entity 코드
 */
export const getDirectorsAndShareholders = async (entityCd: string) => {
  const response = await apiClient.get(`/startTask/common/officers-by-entity-director/${entityCd}`);
  return response;
};

/**
 * Controller Appointment Task 생성
 * @param data - Task 생성 데이터
 */
export interface CreateControllerAppointmentTaskRequest {
  entityCd: string;
  taskTypeCd: string;
  taskTypeName: string;
  taskTitle: string;
  taskFlow: {
    createDocument: boolean;
    requestTSign: boolean;
    proceedWithEFiling: boolean;
  };
  templateIds?: string[];
  controllerData?: {
    // 기본 정보
    confirmationByRegistrableController?: string; // 'true' | 'false'
    requireControllerSignature?: string; // 'true' | 'false'
    controllerName?: string; // CONTACT_CD
    representativeName?: string; // CONTACT_CD (조건부)
    signatory?: string; // CONTACT_CD
    signatoryName?: string; // CONTACT_CD (조건부)
    dateOfAppointed?: string; // YYYY-MM-DD
    
    // Category
    categoryCd?: string; // 'B09001' (Corporate) | 'B09002' (Individual)
    
    // Individual 필드
    nationalityCd?: string;
    identityCardOrPassport?: string;
    dateOfBirth?: string; // YYYY-MM-DD
    aliases?: string;
    
    // Corporate 필드
    acraUen?: string;
    nonAcraUen?: string;
    legalForm?: string;
    jurisdiction?: string;
    incorporationStatute?: string;
    corporateEntityRegister?: string;
    
    // Address 필드
    addressTypeCd?: string; // 'B07001' (Local) | 'B07002' (Foreign)
    postalCode?: string;
    blockHouseNo?: string;
    streetName?: string;
    level?: string;
    unit?: string;
    buildingEstateName?: string;
    foreignAddressLine1?: string;
    foreignAddressLine2?: string;
    
    // Contact 필드
    emailAddress?: string;
    countryCode?: string;
    areaCode?: string;
    mobileNo?: string;
  };
}

export interface CreateControllerAppointmentTaskResponse {
  taskId: number;
  taskTitle: string;
  templateMaps: Array<{
    tmpId: string;
    mapId: number;
  }>;
  docCustSaves: Array<{
    tmpId: string;
    mapId: number;
    saveId: number;
  }>;
  message: string;
}

export const createControllerAppointmentTask = async (
  data: CreateControllerAppointmentTaskRequest
) => {
  const response = await apiClient.post('/startTask/controller-appointment/tasks', data);
  return response;
};

/**
 * Controller Appointment Task의 eFilingData 업데이트
 * @param taskId - Task ID
 * @param eFilingData - 업데이트할 eFilingData
 */
export const updateControllerAppointmentEFilingData = async (
  taskId: number | string,
  eFilingData: any
) => {
  const response = await apiClient.put(
    `/startTask/controller-appointment/update-efiling-data/${taskId}`,
    { eFilingData }
  );
  return response;
};

